import { makeStyles } from '@material-ui/core/styles';

export const makeDashboardDetailsStyles = makeStyles((theme) => ({
  'list-details__description': { color: theme.colorTextSecondary },
  section__title: { color: theme.colorTextSecondary },
}));
